const EN = window.EN || {};
const EN_KO = window.EN_KO || {};
export {
	EN,
	EN_KO,
};
